import './Start.css';
import { InBank } from '../components/InBank/InBank';
import { TimeLine } from '../components/TimeLine/TimeLine';
import buttleIco from '../../../images/ico-battle.png';
import { Border } from '../../../components/Border/Border';

export const Start = () => {
    // @ts-ignore
    return (
        <div className="classic__start">
            <TimeLine />
            <Border />
            <InBank />
            <div className="classic__down-container">
                <img src={buttleIco} alt="" className="classic__img" />
                <span className="classic__text">Батл начался! Заливай ставки!</span>
            </div>
        </div>
    );
};
